$(function () {
    if($('.page--auth').length){

        $("#Form_AdminLoginSubmit").submit(function(e){
            e.preventDefault();
            var url = $(this).attr('action');
            var data = $(this).serialize();
            $.post({
                url: url,
                data: data
            }, function (result) {
                if(result == "1"){
                    location.href = "/admin";
                }else{
                    $('.login-err-msg').show();
                }
            });
        });
    }
});